var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAttention = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2C6.48608 2 2 6.48608 2 12C2 17.5139 6.48608 22 12 22C17.5139 22 22 17.5139 22 12C22 6.48608 17.5139 2 12 2ZM12 4C7.58887 4 4 7.58887 4 12C4 16.4111 7.58887 20 12 20C16.4111 20 20 16.4111 20 12C20 7.58887 16.4111 4 12 4ZM12.5 18H11.5C11.2239 18 11 17.7761 11 17.5V16.5C11 16.2239 11.2239 16 11.5 16H12.5C12.7761 16 13 16.2239 13 16.5V17.5C13 17.7761 12.7761 18 12.5 18ZM12.5 14H11.5C11.2239 14 11 13.7761 11 13.5V7C11 6.72386 11.2239 6.5 11.5 6.5H12.5C12.7761 6.5 13 6.72386 13 7V13.5C13 13.7761 12.7761 14 12.5 14Z",
  fill: "#DB5C64"
})));
export default SvgAttention;